import { useState } from 'react'
import logger from '../utils/logger'
import { authenticatedFetch } from '../services/api/apiClient'
import { apiEndpoints } from '../consts'

const useCampaignDrawerData = ({ startDate, endDate }) => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [selectedCampaign, setSelectedCampaign] = useState(null)
  const [campaignMetrics, setCampaignMetrics] = useState(null)
  const [loadingMetrics, setLoadingMetrics] = useState(false)
  const [error, setError] = useState(null)

  const fetchCampaignMetrics = async (campaignName) => {
    try {
      setLoadingMetrics(true)
      setError(null)

      const startDateISO = startDate.toISOString()
      const endDateISO = endDate.toISOString()

      const response = await authenticatedFetch(
        `${apiEndpoints.campaignMetrics(campaignName)}?startDate=${startDateISO}&endDate=${endDateISO}`
      )

      if (!response.ok) {
        throw new Error(`Failed to fetch campaign metrics: ${response.status}`)
      }

      const data = await response.json()
      logger.debug('Campaign metrics received:', data)
      if (data.avgCssScore) {
        logger.debug('Using backend-provided average CSS score', {
          avgCssScore: data.avgCssScore
        })
      } else {
        logger.debug('No average CSS score provided by backend')
      }

      setCampaignMetrics(data)
      return data
    } catch (err) {
      logger.error('Error fetching campaign metrics:', err)
      setError(err.message)
      return null
    } finally {
      setLoadingMetrics(false)
    }
  }

  const handleCampaignClick = (campaign) => {
    setSelectedCampaign(campaign)
    setDrawerOpen(true)
    fetchCampaignMetrics(campaign.campaign_name)
  }

  const handleDrawerClose = () => {
    setDrawerOpen(false)
    setSelectedCampaign(null)
    setCampaignMetrics(null)
  }

  const resetCampaignMetrics = () => {
    setCampaignMetrics(null)
  }

  return {
    drawerOpen,
    selectedCampaign,
    campaignMetrics,
    loadingMetrics,
    error,

    handleCampaignClick,
    handleDrawerClose,
    fetchCampaignMetrics,
    resetCampaignMetrics
  }
}

export default useCampaignDrawerData
